import type { ValueOf } from "@p-ban/common/src/types"

const MANUFACTURE_COURSE = {
  ultraQuick: { key: "ultraQuick", name: "ウルトラクイック", value: "4", option: true },
  superQuick: { key: "superQuick", name: "スーパークイック", value: "1", option: false },
  quick: { key: "quick", name: "クイック", value: "2", option: false },
  normal: { key: "normal", name: "ノーマル", value: "3", option: false },
  massProduction: { key: "massProduction", name: "量産", value: "7", option: false },
} as const

export default MANUFACTURE_COURSE

export type ManufactureCourse = ValueOf<typeof MANUFACTURE_COURSE>

export const getManufactureCourseByValue = (value: string): ManufactureCourse => {
  const course = Object.values(MANUFACTURE_COURSE).find((nameValue) => nameValue.value === value)
  if (course === undefined) {
    throw new Error(`製造コースの取得に失敗しました。value: ${value}`)
  }
  return course
}
